'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    font-size: 12px;\n    height: 24px;\n  '], ['\n    font-size: 12px;\n    height: 24px;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    font-size: 12px;\n    height: 32px;\n  '], ['\n    font-size: 12px;\n    height: 32px;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    font-size: 14px;\n    height: 40px;\n  '], ['\n    font-size: 14px;\n    height: 40px;\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n  width: 100%;\n  border-style: ', ';\n  border-color: ', ';\n  border-width: 2px;\n  border-radius: 3px;\n  position: relative;\n  display: flex;\n  ', ';\n  ', ';\n\n  ', ';\n'], ['\n  width: 100%;\n  border-style: ', ';\n  border-color: ', ';\n  border-width: 2px;\n  border-radius: 3px;\n  position: relative;\n  display: flex;\n  ', ';\n  ', ';\n\n  ', ';\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n      background: ', ';\n      cursor: not-allowed;\n    '], ['\n      background: ', ';\n      cursor: not-allowed;\n    ']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Styles


var sizes = {
  small: (0, _styledComponents.css)(_templateObject),
  normal: (0, _styledComponents.css)(_templateObject2),
  large: (0, _styledComponents.css)(_templateObject3)
};

var borderColor = function borderColor(_ref) {
  var focused = _ref.focused,
      error = _ref.error,
      disabled = _ref.disabled;
  if (disabled) return _colors.grey;
  if (error) return _colors.red;
  return focused ? _colors.darkGrey : _colors.grey;
};

var InputContainer = _styledComponents2.default.div(_templateObject4, function (_ref2) {
  var noBorder = _ref2.noBorder;
  return noBorder ? 'none' : 'solid';
}, borderColor, function (_ref3) {
  var size = _ref3.size;
  return sizes[size];
}, (0, _polished.transitions)('border-color .2s ease-in-out'), function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled && (0, _styledComponents.css)(_templateObject5, _colors.grey);
});

exports.default = InputContainer;